module.exports = __webpack_public_path__ + "img/down-arrows.0a7ade1a.svg";